module.exports = __webpack_public_path__ + "static/media/expired.b2cd7064.jpeg";